import { bool, number, string, shape, object } from 'prop-types';
import React from 'react';
import Figure from 'components/Figure';
import { MQ_MIDLARGE, MQ_LARGE, MQ_MEDIUM } from 'constants/mq';
import Html from 'components/Html';
import styles from './styles';

export default function Listicle({
  image,
  html,
  title,
  isAffiliate,
  hasPrism,
  post
}) {
  return (
    <div className="Listicle">
      <Figure
        maxWidth={584}
        placement="inPost"
        isAffiliate={isAffiliate}
        hasPrism={hasPrism}
        sourceSizes={[
          {
            media: MQ_MIDLARGE,
            layoutWidth: {
              value: 584,
              units: 'px'
            }
          },
          {
            media: MQ_LARGE,
            layoutWidth: {
              value: 488,
              units: 'px'
            }
          },
          {
            media: MQ_MEDIUM,
            layoutWidth: {
              value: 542,
              units: 'px'
            }
          },
          {
            layoutWidth: {
              value: 100,
              units: 'vw'
            }
          }
        ]}
        post={post}
        {...image}
      />
      <Html html={title} isAffiliate={isAffiliate} />
      <Html html={html} isAffiliate={isAffiliate} />
      <style jsx>{styles}</style>
    </div>
  );
}

Listicle.defaultProps = {
  html: '',
  title: '',
  image: {},
  isAffiliate: false,
  hasPrism: false
};

Listicle.propTypes = {
  html: string,
  title: string,
  image: shape({
    url: string,
    alt: string,
    caption: string,
    href: string,
    isPinnable: bool,
    originalWidth: number,
    originalHeight: number
  }),
  post: shape({
    ads: shape({
      targeting: object
    }),
    canonical: string,
    title: string
  }).isRequired,
  isAffiliate: bool,
  hasPrism: bool
};
